export const depoimentosPlanos = [
  {
    id: 1,
    nome: 'Mariana Costa',
    plano: 'Identidade Futura',
    valorPlano: 'R$ 697',
    texto: 'Esse exercício mudou completamente minha forma de pensar sobre o futuro. Consegui visualizar com clareza quem eu preciso me tornar para alcançar meus objetivos. As cartas programadas me mantêm focada e motivada todos os dias.',
    nota: 5,
    foto: 'https://public.readdy.ai/ai/img_res/aad82f76c211f035e67898fdabb556cc.jpg',
    resultado: 'Promoção conquistada em 6 meses'
  },
  {
    id: 2,
    nome: 'Rafael Mendes',
    plano: 'Direção',
    valorPlano: 'R$ 297',
    texto: 'A Ponte ao Futuro me ajudou a sair da estagnação. Hoje tenho um plano claro de onde quero estar daqui a 3 anos. Os checkpoints semestrais são essenciais para manter o foco e ajustar a rota quando necessário.',
    nota: 5,
    foto: 'https://readdy.ai/api/search-image?query=professional%20man%20smiling%20confident%20portrait%20natural%20light%20warm%20tones%20business%20casual%20shirt%20genuine%20happy%20expression%20modern%20clean%20background&width=200&height=200&seq=depo2&orientation=squarish',
    resultado: 'Mudança de carreira bem-sucedida'
  },
  {
    id: 3,
    nome: 'Juliana Ferreira',
    plano: 'Clareza',
    valorPlano: 'R$ 97',
    texto: 'Comecei com o plano Essencial e já senti uma diferença enorme na minha clareza mental. O áudio guiado é incrível e as perguntas de autoconhecimento me fizeram refletir profundamente sobre o que realmente importa.',
    nota: 5,
    foto: 'https://readdy.ai/api/search-image?query=young%20woman%20smiling%20peaceful%20portrait%20natural%20light%20soft%20tones%20casual%20elegant%20clothing%20serene%20expression%20minimalist%20background&width=200&height=200&seq=depo3&orientation=squarish',
    resultado: 'Maior autoconhecimento e foco'
  },
  {
    id: 4,
    nome: 'Carlos Eduardo',
    plano: 'Vida Extraordinária',
    valorPlano: 'R$ 1.497',
    texto: 'Investimento que valeu cada centavo. O planejamento de 5 anos me deu uma visão estratégica que eu nunca tive. As ferramentas de decisão me ajudaram a fazer escolhas mais alinhadas com meu propósito de vida.',
    nota: 5,
    foto: 'https://readdy.ai/api/search-image?query=mature%20professional%20man%20smiling%20confident%20portrait%20natural%20light%20executive%20business%20attire%20successful%20expression%20elegant%20background&width=200&height=200&seq=depo4&orientation=squarish',
    resultado: 'Negócio próprio lançado com sucesso'
  },
  {
    id: 5,
    nome: 'Beatriz Almeida',
    plano: 'Clube Eu do Futuro',
    valorPlano: 'R$ 57/mês',
    texto: 'A assinatura mensal é perfeita para quem quer manter a prática constante. Todo mês recebo novos exercícios que me desafiam e me fazem evoluir. A comunidade também é muito inspiradora e acolhedora.',
    nota: 5,
    foto: 'https://readdy.ai/api/search-image?query=woman%20smiling%20joyful%20portrait%20natural%20light%20warm%20tones%20casual%20chic%20clothing%20authentic%20happy%20expression%20bright%20background&width=200&height=200&seq=depo5&orientation=squarish',
    resultado: 'Hábito de reflexão consolidado'
  },
  {
    id: 6,
    nome: 'Fernando Silva',
    plano: 'Identidade de Alta Performance',
    valorPlano: 'R$ 197',
    texto: 'O exercício de Alta Performance foi transformador. Consegui identificar crenças limitantes que me impediam de crescer e construí uma nova identidade alinhada com meus objetivos. Recomendo muito!',
    nota: 5,
    foto: 'https://readdy.ai/api/search-image?query=athletic%20man%20smiling%20confident%20portrait%20natural%20light%20sporty%20casual%20attire%20determined%20expression%20modern%20background&width=200&height=200&seq=depo6&orientation=squarish',
    resultado: 'Aumento de 40% na produtividade'
  }
];

export const estatisticasSatisfacao = {
  notaMedia: 4.9,
  totalAvaliacoes: 2847,
  percentualRecomendacao: 97,
  usuariosAtivos: 15420
};
